export default {
  videoContainer: {
    height: '100%',
    width: '100%',
    position: 'relative',
    video: {
      objectFit: 'cover'
    }
  },
  thumbnail: {
    objectFit: 'cover'
  },
  videoStyles: (fullscreen: boolean, fitVideo: boolean) => {
    return {
      width: '100%',
      height: '100%',
      objectFit: fitVideo ? 'contain' : 'cover',
      display: 'block',
      ...(fullscreen ? {} : {
        '&::-webkit-media-controls-fullscreen-button': {
          display: 'none !important'
        }
      })
    };
  }
};